import { handleColorType } from '@quizzach/styles';
import { useTheme } from 'styled-components';

export const UserCircleLight = ({
	color,
	size,
}: {
	color?: string;
	size?: number;
}) => {
	const theme = useTheme();

	return (
		<svg
			width={size || '42'}
			height={size || '42'}
			viewBox='0 0 42 42'
			fill='none'
			className='login-icon'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M13.3326 16.5549C13.3326 12.3209 16.7649 8.88862 20.9989 8.88862C25.2329 8.88862 28.6652 12.3209 28.6652 16.5549C28.6652 20.7889 25.2329 24.2212 20.9989 24.2212C16.7649 24.2212 13.3326 20.7889 13.3326 16.5549ZM20.9989 10.8886C17.8695 10.8886 15.3326 13.4255 15.3326 16.5549C15.3326 19.6843 17.8695 22.2212 20.9989 22.2212C24.1283 22.2212 26.6652 19.6843 26.6652 16.5549C26.6652 13.4255 24.1283 10.8886 20.9989 10.8886Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 20.9989C0 9.40153 9.40153 0 20.9989 0C32.5963 0 41.9978 9.40153 41.9978 20.9989C41.9978 32.5963 32.5963 41.9978 20.9989 41.9978C9.40153 41.9978 0 32.5963 0 20.9989ZM20.9989 2C10.5061 2 2 10.5061 2 20.9989C2 26.1122 4.02 30.7537 7.30554 34.169C8.31632 32.1532 9.96814 30.4097 12.0707 29.111C14.6507 27.5175 17.7888 26.6659 20.9989 26.6659C24.209 26.6659 27.3471 27.5175 29.9271 29.111C32.0297 30.4097 33.6815 32.1532 34.6923 34.169C37.9778 30.7537 39.9978 26.1122 39.9978 20.9989C39.9978 10.5061 31.4917 2 20.9989 2ZM33.1519 35.6031C32.3678 33.738 30.8971 32.0609 28.8761 30.8126C26.6349 29.4283 23.8658 28.6659 20.9989 28.6659C18.132 28.6659 15.3629 29.4283 13.1217 30.8126C11.1007 32.0609 9.63005 33.738 8.84594 35.6031C12.1398 38.3471 16.3766 39.9978 20.9989 39.9978C25.6212 39.9978 29.858 38.3471 33.1519 35.6031Z'
				fill={color ? handleColorType(color, theme) : '#00FFC2'}
			/>
		</svg>
	);
};
